import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50864342"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-w-full tw-bg-[#F8FBFD] tw-border-[#DFDFDF] tw-border-solid tw-border-[1px] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-5" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_5 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_7 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_8 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_9 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-center tw-flex-wrap tw-gap-2" }
const _hoisted_12 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_14 = { class: "offer-attachments tw-grid tw-w-full" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end tw-pt-6 tw-box-border tw-border-t-dashed-custom tw-gap-4" }

import moment from "moment";
import { computed, ref, onMounted } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage, imageExtensions } from "@/core/utils/common";
import Button from "./ui/general/Button.vue";
import Text from "./ui/general/Text.vue";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import appFilters from "@/filters";
import { setDirectStoragePathToImage } from "@/core/utils/common";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewEvidenceModal',
  props: {
  projectData: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-submit"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;

const store = useStore();
const internalInstance = getCurrentInstance();
const isUploadImg = ref<boolean>(false);

const disputeProject = computed(() => {
  return store.getters[`${PROJECT_STORE}/getDisputeProject`];
});

const attachments = computed(() => {
  return disputeProject.value?.attachment;
});
const getAttachmentPath = (attachment: any): any => {
  return setDirectStoragePathToImage(attachment);
};
const time = computed(() => {
  return moment(disputeProject.value?.erp_raised_date).local().format("h A");
});

const date = computed(() => {
  return appFilters.formatToDate(disputeProject.value?.erp_raised_date);
});

const projectName = computed(() => {
  if (!disputeProject.value?.estimatePhases.length) {
    return props.projectData?.name;
  }
  return disputeProject.value?.estimatePhases
    .map((phase: any) => phase.name)
    .join(", ");
});

const contractorNames = computed(() => {
  if (disputeProject.value?.subcontractors.length) {
    return disputeProject.value?.subcontractors
      .map((contractor: any) => contractor.name)
      .join(", ");
  }
  return "--";
});

const isImageType = (attachment: any) => {
  return imageExtensions.some((ext) => attachment?.toLowerCase().endsWith(ext));
};

const onAcceptOffer = async () => {
  emits("on-close");
  return;
};

const onClickBackButton = () => {
  return emits("on-close");
};

onMounted(() => {
  console.log(props.projectData, "project data");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    headerTitle: "Evidence",
    width: "588px",
    isTitleStrong: true,
    borderRadius: "20px"
  }, _createSlots({
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Text, {
              variant: "h6",
              lineHeight: "18px",
              textWeight: "400"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Project Details")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Project:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(projectName.value), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Contractor Name:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px",
                isCapitalize: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(contractorNames.value), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Text, {
              variant: "h6",
              lineHeight: "18px",
              textWeight: "400"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submission Details")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Date:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(date.value), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Time:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(time.value), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Address:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("--")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Coordinates:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("--")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Text, {
                variant: "h6",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Creator:")
                ]),
                _: 1
              }),
              _createVNode(Text, {
                variant: "h6",
                textWeight: "400",
                textAlign: "left",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("--")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(Text, {
              variant: "h6",
              lineHeight: "18px",
              textWeight: "400"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Statement")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              variant: "h6",
              textWeight: "400",
              textAlign: "left",
              lineHeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(disputeProject.value?.description), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Text, {
              variant: "h6",
              textWeight: "400"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Attachments")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tw-rounded-[8.72px] tw-overflow-hidden tw-w-full tw-h-[94px]",
                  key: index
                }, [
                  (isImageType(attachment))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getAttachmentPath(attachment),
                        alt: "Image",
                        class: "tw-w-full tw-h-full tw-object-cover"
                      }, null, 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "tw-w-full tw-h-full tw-object-cover",
                        src: require('@/assets/icons/sidebar-icons/documents.svg'),
                        alt: "icon"
                      }, null, 8, _hoisted_16))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 2
  }, [
    (!props.isSenderUser)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("section", _hoisted_17, [
              _createVNode(Button, {
                class: "!tw-w-auto",
                variant: "secondary",
                label: "Close",
                onClick: onClickBackButton
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})